module.exports = __webpack_public_path__ + "assets/manual_express-d50baee090739b33af04b55d003ec977.pdf";